"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
export interface McpServer {
  id: string;
  name: string;
  url: string;
  apiKey: string;
  enabled: boolean;
}
const MCP_SERVERS_KEY = "llmgateway_mcp_servers";
export function useMcpServers() {
  const $ = _c(18);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [servers, setServers] = useState(t0);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (typeof window !== "undefined") {
        try {
          const stored = localStorage.getItem(MCP_SERVERS_KEY);
          if (stored) {
            const parsed = JSON.parse(stored);
            if (Array.isArray(parsed)) {
              setServers(parsed);
            }
          }
          setError(null);
        } catch {
          setError("Failed to load MCP servers configuration");
          toast.error("Failed to load MCP servers configuration");
        }
        setIsLoaded(true);
      }
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== isLoaded || $[4] !== servers) {
    t3 = () => {
      if (isLoaded && typeof window !== "undefined") {
        try {
          if (servers.length === 0) {
            localStorage.removeItem(MCP_SERVERS_KEY);
          } else {
            localStorage.setItem(MCP_SERVERS_KEY, JSON.stringify(servers));
          }
          setError(null);
        } catch {
          setError("Failed to save MCP servers configuration");
          toast.error("Failed to save MCP servers configuration");
        }
      }
    };
    t4 = [servers, isLoaded];
    $[3] = isLoaded;
    $[4] = servers;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = server => {
      const newServer = {
        ...server,
        id: crypto.randomUUID()
      };
      setServers(prev => [...prev, newServer]);
      return newServer;
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const addServer = t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = (id, updates) => {
      setServers(prev_0 => prev_0.map(server_0 => server_0.id === id ? {
        ...server_0,
        ...updates
      } : server_0));
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const updateServer = t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = id_0 => {
      setServers(prev_1 => prev_1.filter(server_1 => server_1.id !== id_0));
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const removeServer = t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = id_1 => {
      setServers(prev_2 => prev_2.map(server_2 => server_2.id === id_1 ? {
        ...server_2,
        enabled: !server_2.enabled
      } : server_2));
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const toggleServer = t8;
  let t9;
  if ($[11] !== servers) {
    t9 = () => servers.filter(_temp);
    $[11] = servers;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const getEnabledServers = t9;
  let t10;
  if ($[13] !== error || $[14] !== getEnabledServers || $[15] !== isLoaded || $[16] !== servers) {
    t10 = {
      servers,
      isLoaded,
      error,
      addServer,
      updateServer,
      removeServer,
      toggleServer,
      getEnabledServers
    };
    $[13] = error;
    $[14] = getEnabledServers;
    $[15] = isLoaded;
    $[16] = servers;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}
function _temp(server_3) {
  return server_3.enabled;
}